<template>
  <DxPopup @hidden="onHidden" :visible="showShipDetail" :show-close-button="true" :show-title="true" :title="'Ship Detail Information'" height="500px" width="300px" >      
    
      <v-row dense class="form-layout" >
        <v-col cols="12">                  
            <v-row > 
              <v-col cols="5"  >
                <span class="subTitle">Description</span>                
              </v-col>
              <v-col dense cols="7">
                {{shipdetail.shipDesc}}
              </v-col>
            </v-row>
            <v-row dense >
              <v-col dense cols="5" >
                <span class="subTitle">Dock</span>                
              </v-col>
              <v-col cols="7" >               
                 {{shipdetail.dock}}
              </v-col>
            </v-row>   
            <v-row dense >
              <v-col dense cols="5" >
                <span class="subTitle">Seri No</span>                
              </v-col>
              <v-col cols="7" >               
                 {{shipdetail.seriesNo}}
              </v-col>
            </v-row>                
            <v-row dense>
              <v-col cols="5">
                <span class="pa-1 subTitle">Ship Kind</span>                
              </v-col>
              <v-col cols="7" >
                {{shipdetail.sKind}}
              </v-col>
            </v-row>       
            <v-row dense >
              <v-col cols="5" >
                <span class="pa-1 subTitle">Owner/ Class</span>                
              </v-col>
              <v-col cols="7" class="pa-1" >
                {{shipdetail.owner}}
              </v-col>
            </v-row>  
            <v-row dense class="form-layout">
              <v-col cols="5" >
                <span class="pa-1 subTitle">Const. Method</span>                
              </v-col>
              <v-col cols="7" class="pa-1" >
                {{shipdetail.shipbuildgubun}}
              </v-col>
            </v-row>   
            <v-row dense class="form-layout">
              <v-col cols="5">
                <span class="pa-1 subTitle">L.O.A/L.B.P</span>                
              </v-col>
              <v-col cols="7" class="pa-1" >
                {{shipdetail.sLengh}}   
              </v-col>
            </v-row> 
            
            <v-row dense class="form-layout">
              <v-col cols="5" >
                <span class="pa-1 subTitle">Breadth</span>                
              </v-col>
              <v-col cols="7" class="pa-1" >
                {{shipdetail.sBreath}} 
              </v-col>
            </v-row> 
            <v-row dense class="form-layout">
              <v-col cols="5" >
                <span class="pa-1 subTitle">WC Date</span>                
              </v-col>
              <v-col cols="7" class="pa-1" >
                {{shipdetail.wcDate}}
              </v-col>
            </v-row> 
            <v-row dense class="form-layout">
              <v-col cols="5" >
                <span class="pa-1 subTitle">KL Date</span>                
              </v-col>
              <v-col cols="7" class="pa-1" >
                {{shipdetail.klDate}}
              </v-col>
            </v-row> 
            <v-row dense class="form-layout">
              <v-col cols="5" >
                <span class="pa-1 subTitle">LC Date</span>                
              </v-col>
              <v-col cols="7" class="pa-1" >
                {{shipdetail.lcDate}}
              </v-col>
            </v-row> 
            <v-row dense class="form-layout">
              <v-col cols="5">
                <span class="pa-1 subTitle">DL Date</span>                
              </v-col>
              <v-col cols="7" >
                {{shipdetail.dlDate}}
              </v-col>
            </v-row>  
        </v-col>
      </v-row>               
</DxPopup>
</template>

<script>

import { DxPopup } from 'devextreme-vue/popup'
import {getv20a1000, getEmpPic} from '@/api/view/pp/20/v20a1000.js' 

export default {
  name: 'v20a1000detail',  
  props: {
    showShipDetail: {
      type: Boolean,
      default() {
        return false
      }
    },
    shipNo: {
      type: String,
      default() {
        return ''
      }
    }
  }, 
  components: { 
    DxPopup
    },
     
  data: () => ({     
    shipdetail: {}   
  }),

  watch: {
    'showShipDetail': {
      handler(value, oldValue) {
        if(value) {
          this.btnRetrieve()          
        }
      },
      immediate: true
    }
  },

   methods: {

      btnRetrieve(){     
        this.doSearchShipDetail()
      },
      async doSearchShipDetail(){

            const events = []      
            // this.openLoading('searching')

            let params = {              
              shipNo: this.shipNo,
              shipGu: '%'
            } 

            console.log( params)

            await getv20a1000(params).then(res => {
                 res.list.forEach(e => {
                e.id = e.rnum
              });        
            this.shipdetail = res.list[0]

            console.log( this.shipdetail.shipDesc)
          
            }).finally(() => {
              // 
            })

        },  
      
        async getEmpPicture(empno) {
            try {
              this.openLoading('searching')
              let params = {
                deptCd: "",
                grpCd: "",
                appCd: "",
                empNo: empno,
              }
              await getEmpPic(params).then(res => {
                this.empPic = res.body;
                console.log('res', res);
              })

            } finally {
              this.endLoading()
            }
          },

    onHidden(e) {
      this.$emit('update:showShipDetail', false)
    }    

    },

    

};
</script>


<style lang="scss" scoped>
$redBtn: #FF0000;

.form-layout::v-deep .col {
  border-start-start-radius: 30px 30px;
  border-width: 1px 1px 1px 1px;
  border-style: solid;
  border-color: rgb(131, 221, 12);
  
  * {
    border: 1px none !important;
  }

  .row {
    border-width: 0 0 1px 0 !important;
    border-style: dotted !important;
    border-color: rgb(37, 224, 20) !important;
  }

  // .col {   
  //   border-width: 0 0px 0 0 !important;
  //   border-style: solid !important;
  //   border-color: gray !important;
  // }

}
.formHeader {
   background-color: rgb(164, 173, 36);
   font-weight: bold;
   // border: 1px solid gray;
   color: black;
   font-size: 9pt;
 }

.subTitle {
  font-weight: bold;
  color: rgb(0, 0, 0);
}
.subTitle2 {
  font-weight: bold;
  color: red;
}

</style>